import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CustomInputGroupModule } from "src/app/custom-input-group/custom-input-group.module";
import { NodataModule } from "src/app/nodata/nodata.module";
import { PipesModule } from "src/app/pipes/pipes.module";
import { SkeletonLoaderModule } from "src/app/skeleton-loader/skeleton-loader.module";
import { DisplayCurrencyModule } from "../display-currency/display-currency.module";
import { AlternatePaymentModalComponent } from "./alternate-payment-modal.component";

@NgModule({
  declarations: [AlternatePaymentModalComponent],
  imports: [
    CommonModule,
    PipesModule,
    DisplayCurrencyModule,
    NodataModule,
    CustomInputGroupModule,
    FormsModule,
    ReactiveFormsModule,
    SkeletonLoaderModule,
  ],
  exports: [AlternatePaymentModalComponent],
})
export class AlternatePaymentModalModule {}
